import {i18n} from "./i18n";
import UrlHelpers from "./url";
import {addIcon} from "./icons";
import {Notification} from "./notification";
import {FieldHandler} from "./fieldHandler";
import {setContextActions} from "./contextActions";
import {provider_created, provider_edit_delete, provider_edit_saved} from "./dapiEventUris";
import {ErrorHandler} from "./errorHandler";

export class ProviderList {
    private _dapi: Dapi = (<any>window).dapi;
    private _dux = (<any>window).dux;
    private _i18n: i18n = new i18n();

    constructor() {
        this._dapi.addResourceEventListener('changed', this._dapi_event);
        this._dapi.addResourceEventListener('deleted', this._dapi_event);
        this._addCtxActions();
        let createModalDialog = this._dux.query('#modalCreateProvider');
        if(createModalDialog){
            createModalDialog.on('hidden.bs.modal', (e)=> {
                let inputProviderName = <HTMLInputElement>document.getElementById('providerName');
                inputProviderName.value = '';
                let inputProviderPrefix = <HTMLInputElement>document.getElementById('providerPrefix');
                inputProviderPrefix.value = '';
            });
        }
    }

    private _dapi_event = (resourceEvent: IResourceEvent) => {
        switch(resourceEvent.uri) {
            case provider_edit_delete:
            case provider_edit_saved:
            case provider_created:
                window.location.reload(true);
        }
    };

    private _addCtxActions = () => {
        let ctx = new Array<IContextAction>();
        if(UrlHelpers.getMetaData('sysAdmin')){
            ctx.push({
                title:this._i18n.getTranslation('provider_list_ctx_action_btn_create_label'), //"Neuen Provider erstellen",
                icon: addIcon,
                callback: () => {
                    this._ctx_create_provider();
                }
            });
        }
        // this._dapi.setContextActions(ctx);
        setContextActions(this._dapi, this._i18n, ctx);
    };

    private _ctx_create_provider = () => {
        this._dux.query('#modalCreateProvider').modal('toggle');
        (<HTMLButtonElement>document.getElementById('modalCreateProvider_btnAdd')).addEventListener('click', this._create_provider);
    };

    private _create_provider = () => {
        let name = FieldHandler.getFieldValue('providerName');
        if (name.isNullOrEmpty()) {
            FieldHandler.setFieldError('providerName', this._i18n.getTranslation('provider_prop_name_error_is_empty'));
            return
        }
        let prefix = FieldHandler.getFieldValue('providerPrefix');
        if(prefix.isNullOrEmpty()){
            FieldHandler.setFieldError('providerPrefix', this._i18n.getTranslation('providerList_create_provider_error_prefix_empty_message'));
            return
        } else if(prefix.length < 2) {
            FieldHandler.setFieldError('providerPrefix', this._i18n.getTranslation('providerList_create_provider_error_prefix_to_short_message'));
            return
        } else if(prefix.length > 15){
            FieldHandler.setFieldWarning('providerPrefix', this._i18n.getTranslation('providerList_create_provider_info_prefix_max_length_reference_message'))
        }
        // todo: check, if prefix is not in use as web service call. When check ok, activate button to create the provider. Otherwise show a message, that the current provider prefix is already in use by another provider

        let url = UrlHelpers.getLinkRelHref('self');
        let xhr = new XMLHttpRequest();

        let dto:dtoCreateProviderRequest = {
            name:name,
            prefix:prefix
        };

        xhr.open('POST', url);
        xhr.setRequestHeader('accept','application/json');
        xhr.onload = () => {
            if (xhr.status === 201) {
                this._dapi.dispatchResourceEvent({
                    name: "changed",
                    uri: provider_created
                });
                let url = xhr.getResponseHeader('location');
                this._dux.query('#modalCreateProvider').modal('hide');
                this._dapi.navigate(url);
            } else if (xhr.status === 422) {
                this._dux.query('#modalCreateProvider').modal('hide');
                Notification.showErrorNotification(this._i18n.getTranslation('providerList_error_provider_limit_reached_title'), this._i18n.getTranslation('providerList_error_provider_limit_reached_message'));
            } else if (xhr.status === 409) {
                let error = ErrorHandler.parseError(xhr.responseText);
                switch (error.description) {
                    case "Provider prefix already exist":
                        FieldHandler.setFieldError('providerPrefix', this._i18n.getTranslation('provider_list_modal_create_provider_error_prefix_already_exist_message'));
                        break;
                    case "Provider prefix must contain at least 2 characters":
                        FieldHandler.setFieldError('providerPrefix', this._i18n.getTranslation('providerList_create_provider_error_prefix_to_short_message'));
                        break;
                    case "Provider prefix is invalid":
                        FieldHandler.setFieldError('providerPrefix', this._i18n.getTranslation('providerList_create_provider_error_prefix_invalid_chars_message'));
                        break;
                    case "Provider prefix is blacklisted":
                        FieldHandler.setFieldError('providerPrefix', this._i18n.getTranslation('providerList_create_provider_error_prefix_not_allowed_message'));
                        break;
                    default:
                        Notification.showErrorNotification(this._i18n.getTranslation('provider_list_notification_create_failed_title'), xhr.responseText);
                }
                console.error(xhr.responseText);
            } else if (xhr.status === 400) {
                let error = ErrorHandler.parseError(xhr.responseText);
                switch (error.description) {
                    case "provider name missing":
                        FieldHandler.setFieldError('providerName', this._i18n.getTranslation('provider_name_missing_or_invalid_message'))
                        break;
                }
            } else {
                Notification.showErrorNotification(this._i18n.getTranslation('provider_list_notification_create_failed_title'), this._i18n.getTranslation('provider_list_notification_create_failed_message'));
                console.error(xhr.responseText);
            }
        };
        let json = JSON.stringify(dto);
        xhr.send(json);
    };
}

export interface dtoProvider {
    id:string
    members: string[]
    provider:dtoProviderDetails
}
export interface dtoProviderDetails {
    name:string
    description:string
    logo:string
    email:string
    street:string
    zip:string
    city:string
    country:string
    language:string
    homepage:string
    impressum:string
    supportMail:string
    supportPhone:string
    prefix:string
}
export interface dtoCreateProviderRequest {
    name:string
    prefix:string
}